import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { FabrikatService } from 'src/app/api/services/fabrikat.service';
import { FabrikatDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/fabrikat-dto';
import { FabrikatEditDialogComponent } from '../fabrikat-edit-dialog/fabrikat-edit-dialog.component';
import { AuthService } from 'src/app/services/auth.service';
import { StamdataStatusService } from '../../shared/stamdata-status.service';
import { HistoryViewComponent } from '../../../shared/history/history-view/history-view.component';
import { IHistoryView } from '../../../shared/history/history.model';
import { AuditHistoryEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/audit-history-enum';
import { StamdataStatusEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/stamdata-status-enum';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { EditModelDialogData } from 'src/app/components/aftale/models';
import { ModelEditDialogComponent } from '../../modeller/model-edit-dialog/model-edit-dialog.component';

@Component({
  selector: 'app-fabrikat-list',
  templateUrl: './fabrikat-list.component.html',
  styleUrls: ['./fabrikat-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FabrikatListComponent implements OnInit {
  fabrikater: FabrikatDto[] = [];
  @ViewChild(MatTable) table: MatTable<any>;
  displayedColumns: string[] = ['produktId', 'name', 'fabrikatstatus', 'actions'];

  constructor(
    private dialog: MatDialog,
    private service: FabrikatService,
    private auth: AuthService,
    private statusservice: StamdataStatusService,
  ) {}

  get canEdit() {
    return this.auth.isAdministrator;
  }

  ngOnInit(): void {
    this.init();
  }

  async init() {
    this.fabrikater = await this.service
      .getFabrikater({
        caller: EGIS_SERVICE_CALLER,
      })
      .toPromise();
  }

  edit(row: FabrikatDto) {
    const data = {
      fabrikat: row,
    };

    let dialogRef = this.dialog.open(FabrikatEditDialogComponent, {
      width: '600px',
      maxWidth: '95vw',
      data: data,
    });

    dialogRef.afterClosed().subscribe((p) => {
      if (p) {
        if (row) {
          const reload = this.historyView;
          Object.assign(row, p);
          if (reload) this.showhistory(row);
          this.historyViewComponent.render();
        } else {
          this.fabrikater.push(p);
          this.historyView = null;
        }

        this.table.renderRows();
      }
    });
  }

  add() {
    this.edit({} as FabrikatDto);
  }

  fabrikatstatus(fabrikatstatus: StamdataStatusEnum) {
    return this.statusservice.stamdatastatus(fabrikatstatus);
  }

  @ViewChild(HistoryViewComponent) historyViewComponent: HistoryViewComponent;
  historyView: IHistoryView;
  showhistory(row: FabrikatDto) {
    this.historyView = { entityId: row.id, historyType: AuditHistoryEnum.Fabrikat, title: `${row.name} ${row.produktId}` };
  }

  addmodel(row: FabrikatDto) {
    const data: EditModelDialogData = {
      fabrikater: this.fabrikater,
      fabrikat: row,
    };

    let dialogRef = this.dialog.open(ModelEditDialogComponent, {
      width: '600px',
      maxWidth: '95vw',
      data: data,
    });

    dialogRef.afterClosed().subscribe((p) => {
      if (p) {
        // if (row) {
        //   const reload = this.historyView;
        //   Object.assign(row, p);
        //   if (reload) this.showhistory(row);
        //   this.historyViewComponent.render();
        // } else {
        //   this.historyView = null;
        // }
        // this.table.renderRows();
      }
    });
  }
}
